import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from "react";

const SpriteAni = forwardRef(({ img, xCount, yCount, defaultFrames, frameSec, loop, sloops, onLoad, onComplete, className, id, onClick, sloopsCb }, ref) => {
    const [loaded, setLoaded] = useState(false);
    const animationRef = useRef();
    const frameRef = useRef({});
    const lastFrameRef = useRef(0);
    const stopTimeRef = useRef(0); // 记录停止时的时间点
    const playingRef = useRef(false);
    const containerRef = useRef(null);
    const innerRef = useRef(null);
    const spriteInfoRef = useRef({});
    const [scale, setScale] = useState(1);

    const updateScale = () => {
        if (containerRef.current && spriteInfoRef.current.gridW && spriteInfoRef.current.gridH) {
            const { offsetWidth, offsetHeight } = containerRef.current;
            console.log("offsetWidth, offsetHeight", offsetWidth, offsetHeight, Math.min(offsetWidth / spriteInfoRef.current.gridW, offsetHeight / spriteInfoRef.current.gridH))
            setScale(Math.min(offsetWidth / spriteInfoRef.current.gridW, offsetHeight / spriteInfoRef.current.gridH));
        }
    };

    useEffect(() => {
        const imgElement = new Image();
        imgElement.src = img;
        console.log("img", img)
        imgElement.onload = () => {
            const imgW = imgElement.width;
            const imgH = imgElement.height;

            const gridW = imgW / xCount;
            const gridH = imgH / yCount;
            console.log(imgW, imgH, gridW, gridH)
            spriteInfoRef.current = { imgElement, imgW, imgH, gridW, gridH };
            setLoaded(true);
            if (onLoad)
                onLoad();
            setTimeout(() => {
                updateScale();
            }, 1);
        };
    }, [img, xCount, yCount]);

    useEffect(() => {
        const handleResize = () => updateScale();
        window.addEventListener("resize", handleResize);
        const resizeObserver = new ResizeObserver(handleResize);
        if (containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }
        return () => {
            window.removeEventListener("resize", handleResize);
            if (containerRef.current) {
                resizeObserver.unobserve(containerRef.current);
            }
            cancelAnimationFrame(animationRef.current);
            animationRef.current = null;
        };
    }, []);

    const play = (frames = null, frameDuration = null, shouldLoop = null, sloops = null, onCompleteCallback = null) => {
        if (frames) {
            frameRef.current.frames = frames;
            frameRef.current.sloops = sloops;
            frameRef.current.frameDuration = frameDuration ?? frameSec;
            frameRef.current.shouldLoop = shouldLoop ?? loop;
            frameRef.current.onCompleteCallback = onCompleteCallback ?? onComplete;
            frameRef.current.currentFrame = 0;
            frameRef.current.startTime = performance.now();
            frameRef.current.backIndex = 0;
        } else {
            if (playingRef.current === true) return;
            frameRef.current.currentFrame = lastFrameRef.current;
            frameRef.current.startTime = performance.now() - stopTimeRef.current; // 使用记录的停止时间
            animationRef.current = requestAnimationFrame(animate);
        }

        if (animationRef.current) cancelAnimationFrame(animationRef.current);

        playingRef.current = true;
        animationRef.current = requestAnimationFrame(animate);
    };

    useImperativeHandle(ref, () => ({
        play: (frames = null, frameDuration = null, shouldLoop = null, sloops = null, onCompleteCallback = null) => {
            play(frames, frameDuration, shouldLoop, sloops, onCompleteCallback);
        },
        rePlay: () => {
            if (animationRef.current) cancelAnimationFrame(animationRef.current);
            frameRef.current.currentFrame = 0;
            playingRef.current = true;
            frameRef.current.startTime = performance.now();
            animationRef.current = requestAnimationFrame(animate);
        },
        stop: () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
                animationRef.current = null;
            }
            playingRef.current = false;
            if (frameRef.current.frames) {
                lastFrameRef.current = frameRef.current.currentFrame % frameRef.current.frames.length;
                stopTimeRef.current = performance.now() - frameRef.current.startTime; // 记录停止时的时间
            }
        },
        getEl: () => {
            return containerRef.current;
        },
        continue: () => {
            frameRef.current.sloops = null;
        }
    }));
    const needLoop = (frameIndex) => {
        if (frameRef.current.sloops) {
            if (frameIndex === frameRef.current.sloops[0]) {
                if (sloopsCb)
                    sloopsCb();
            }
            if (frameIndex > frameRef.current.sloops[1]) {
                frameRef.current.backIndex += (frameRef.current.sloops[1] - frameRef.current.sloops[0]) + 1;
                frameIndex--;

            }
            return frameIndex;
        }
        else
            return frameIndex;
    }
    const animate = (timestamp) => {
        if (!playingRef.current) return;
        const { frames, frameDuration, shouldLoop, onCompleteCallback } = frameRef.current;
        if (!frames) return;

        const elapsed = (timestamp - frameRef.current.startTime) / 1000;
        let frameIndex = Math.floor(elapsed / frameDuration) - frameRef.current.backIndex;
        frameIndex = needLoop(frameIndex);
        const frame = frames[frameIndex];
        if (frame !== undefined) {
            const frameX = (frame % xCount) * spriteInfoRef.current.gridW;
            const frameY = Math.floor(frame / xCount) * spriteInfoRef.current.gridH;
            if (innerRef.current) {
                innerRef.current.style.backgroundPosition = `-${frameX}px -${frameY}px`;
            }
        }

        if (frameIndex >= frames.length - 1) {
            if (shouldLoop === false) {
                playingRef.current = false;
                if (onCompleteCallback) onCompleteCallback();
                return;
            }
        } else {
            frameRef.current.currentFrame = frameIndex;
        }
        animationRef.current = requestAnimationFrame(animate);
    };

    useEffect(() => {
        if (loaded) {
            play(defaultFrames, frameSec, loop, sloops, onComplete);
        }
    }, [loaded]);

    if (!loaded) {
        return <div style={{ width: "100%", height: "100%", background: "gray" }} />;
    }

    const { gridW, gridH } = spriteInfoRef.current;
    return (
        <div ref={containerRef} onClick={e => { if (onClick) onClick(e) }} id={id} className={className} style={{ overflow: "hidden" }}>
            <div
                ref={innerRef}
                style={{
                    background: `url(${img})`,
                    width: `${gridW}px`,
                    height: `${gridH}px`,
                    transform: `scale(${scale})`,
                    transformOrigin: 'center center',
                }}
            />
        </div>
    );
});

export default SpriteAni;
